import { Injectable } from '@angular/core';
import { filterAllTruthyInTuple, subjectFromObs } from 'core/rx-js';
import { BehaviorSubject, Subject, combineLatest, distinctUntilChanged, filter, map } from 'rxjs';
import { IPageInfo, PdfViewerService } from '../../pdf-viewer.service';
import { PdfThumbnailViewportsContainerService } from '../pdf-thumbnail-viewports-container/pdf-thumbnail-viewports-container.service';

@Injectable()
export class PdfThumbnailService {
  readonly PNG_BASE64_PREFIX = 'data:image/png;base64, ';

  private readonly _destroy = new Subject<void>();
  readonly pdfPageInfoSubject = new BehaviorSubject<IPageInfo>(undefined);
  readonly PAGE_SPACING = 10;

  readonly pageBase64pngsSubject = this._pdfViewerService.pageBase64pngsSubject;

  readonly imgPathObs = combineLatest([this.pdfPageInfoSubject, this.pageBase64pngsSubject]).pipe(
    filter(Boolean),
    map(([pageInfo, pageBase64pngs]) => pageBase64pngs[pageInfo.pageIdx]),
    map(base64 => base64 ? this.PNG_BASE64_PREFIX + base64 : undefined),
    distinctUntilChanged()
  )

  readonly pdfPageVisibleSubject = subjectFromObs({
    observable: combineLatest([
      this.pdfPageInfoSubject,
      this._pdfThumbnailViewportContainerService.visiblePageRangeSubject,
    ])
      .pipe(
        filterAllTruthyInTuple(),
        map(([pageInfo, { firstRenderedPageIdx, lastRenderedPageIdx }]) =>
          pageInfo.pageIdx > (firstRenderedPageIdx - 2) && pageInfo.pageIdx < (lastRenderedPageIdx + 2)
        ),
        distinctUntilChanged()
      ),
    initialValue: false
  })


  readonly pageIdxSubject = this._pdfViewerService.pageIdxSubject;

  readonly isSelectedObs = combineLatest([this.pdfPageInfoSubject, this.pageIdxSubject])
    .pipe(
      filterAllTruthyInTuple(),
      map(([{ pageIdx }, selectedPageIdx]) => pageIdx === selectedPageIdx)
    )

  constructor(
    private _pdfThumbnailViewportContainerService: PdfThumbnailViewportsContainerService,
    private _pdfViewerService: PdfViewerService
  ) {
  }

  ngOnDestroy() {
    this._destroy.next();
    this._destroy.complete();
  }
}
